import { getSignatures, SignaturesResponse } from "@/api/signatures";
import { QueryClient } from "@tanstack/react-query";
import { useSignatureStore } from "@/stores/v2/signatureStore";

export const signaturesQueryKey = ["signatures"] as const;

/** Fetches the signatures catalog once per session and writes it into {@link useSignatureStore}. */
export async function loadSignatures(queryClient: QueryClient): Promise<SignaturesResponse> {
	const data = await queryClient.fetchQuery({
		queryKey: signaturesQueryKey,
		queryFn: getSignatures,
		cacheTime: Infinity,
		staleTime: Infinity,
	});
	useSignatureStore.getState().setSignatures(data);
	return data;
}
